<template>
    <v-container fluid class="px-0 py-0">
        <template v-if="log">
            <div class="log-summary">
                车牌号：<b>{{log.vehicleLno}}</b> 检查人：<b>{{log.checkerName}}</b> <template class="sign"
                    v-if="log.checkerSign">
                    签字：<img :src="log.checkerSign" />
                </template>
            </div>
            <v-divider />
            <v-tabs icons-and-text show-arrows>
                <v-tab v-for="(l,i) in ['出车前', '行车中', '收车后']" :key="i">
                    <v-icon large>{{'filter_' + (i+1)}}</v-icon> {{l}}
                </v-tab>
                <v-tab-item class="logs" v-for="(l,i) in ['出车前', '行车中', '收车后']" :key="i">
                    <vehicle-check-log :log="logs[cfgs[i+1].cfg.id]" :cfg="cfgs[i+1]" />
                </v-tab-item>
            </v-tabs>
        </template>
    </v-container>
</template>
<script>
const VehicleCheckLog = () => import("../views/vehicle-check-log.vue");
export default {
    name: "vehicle-three-check-log",
    components: {
        VehicleCheckLog
    },
    data() {
        return {
            log: null,
            logs: {},
            cfgs: {}
        };
    },
    methods: {
        init() {
            let self = this, id = self.$route.params._id;
            self.$axios.get(`/home/admin/m/my/tenant/vehicle/three/check/log/detail/${id}`).then(r => {
                let log = r.data.message, logs = r.data.logs, cfgs = r.data.cfgs;
                if (log.checkerSign) {
                    log.checkerSign = `${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/three/check/log/upload/view/checkerSign/${log.checkerSign}?__entity_id=${log.id}`;
                }
                self.log = log;
                for (let l in logs) {
                    l = logs[l];
                    l.logs = JSON.parse(l.logs);
                    let photos = l.photos;
                    if (photos) {
                        let urls = [];
                        photos = photos.split(',');
                        for (let p of photos) {
                            urls.push(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/check/log/upload/view/photos/${p}?__entity_id=${l.id}`);
                        }
                        l.photos = urls;
                    }
                }
                self.logs = logs;
                self.cfgs = cfgs;
            });
        },
    },
    created() {
        this.init();
    },
};
</script>
<style scoped>
.log-summary {
    line-height: 50px;
}

.log-summary b {
    font-size: 30px;
    margin-right: 18px;
    font-weight: normal;
}

.log-summary img {
    max-height: 50px;
}

.v-divider {
    margin: 16px 0;
}
</style>